"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentParam = /** @class */ (function () {
    function PaymentParam(chainId, accountId, assetId, amount) {
        this.chainId = chainId;
        this.accountId = accountId;
        this.assetId = assetId;
        this.amount = amount;
    }
    PaymentParam.prototype.isChainId = function (chainId) {
        return this.chainId.toUpperCase() === chainId.toUpperCase();
    };
    PaymentParam.prototype.isAccountId = function (accountId) {
        return this.accountId.toUpperCase() === accountId.toUpperCase();
    };
    PaymentParam.prototype.isAssetId = function (assetId) {
        return this.assetId.toUpperCase() === assetId.toUpperCase();
    };
    PaymentParam.fromTransferParam = function (param, chainId) {
        return new PaymentParam(chainId, param.accountId, param.assetId, param.amount);
    };
    return PaymentParam;
}());
exports.default = PaymentParam;
//# sourceMappingURL=payment-param.js.map